import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetAllCantons, GetAllCities };

function GetAllCantons(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/cantons", headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetAllCities(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/cities", headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
